export enum SidebarState {
  Open = 'open',
  Closed = 'closed'
}
